$('.shoplist_box dl dt').on('click', function () {
  $(this).next('dd').stop().slideToggle();
  $(this).toggleClass('openTgl');
});






